/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const SET_FETCH_REC_AREA_STATUS = 'SET_FETCH_REC_AREA_STATUS';
export const FETCH_REC_AREA_SUCCESS = 'FETCH_REC_AREA_SUCCESS';
export const FETCH_REC_AREA_ERROR = 'FETCH_REC_AREA_ERROR';

export function fetchRecAreaSuccess(data) {
    return {
        type: FETCH_REC_AREA_SUCCESS,
        payload: data,
    };
}

export function fetchRecAreaError(error) {
    return {
        type: FETCH_REC_AREA_ERROR,
        payload: error,
    };
}

export function setFetchRecAreaStatus(status) {
    return {
        type: SET_FETCH_REC_AREA_STATUS,
        payload: status,
    };
}
